"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TailwindLegacyWrapper = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
require("./TailwindLegacyWrapper.css");
exports.TailwindLegacyWrapper = react_1.default.forwardRef(function (props, ref) { return (react_1.default.createElement("div", __assign({}, props, { ref: ref, className: (0, clsx_1.default)(props.className, 'tailwindWrapper') }))); });
exports.TailwindLegacyWrapper.displayName = 'TailwindLegacyWrapper';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGFpbHdpbmRMZWdhY3lXcmFwcGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vVGFpbHdpbmRMZWdhY3lXcmFwcGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7OztBQUNBLGdEQUEwQjtBQUMxQiw4Q0FBd0I7QUFDeEIsdUNBQXFDO0FBT3hCLFFBQUEscUJBQXFCLEdBQUcsZUFBSyxDQUFDLFVBQVUsQ0FDbkQsVUFBQyxLQUFpQyxFQUFFLEdBQWlDLElBQUssT0FBQSxDQUN4RSxrREFDTSxLQUFLLElBQ1QsR0FBRyxFQUFFLEdBQUcsRUFDUixTQUFTLEVBQUUsSUFBQSxjQUFJLEVBQUMsS0FBSyxDQUFDLFNBQVMsRUFBRSxpQkFBaUIsQ0FBQyxJQUNuRCxDQUNILEVBTnlFLENBTXpFLENBQ0YsQ0FBQztBQUVGLDZCQUFxQixDQUFDLFdBQVcsR0FBRyx1QkFBdUIsQ0FBQyJ9


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/tailwind-legacy-wrapper/TailwindLegacyWrapper.js
// module id = 5244
// module chunks = 25